<div class="help-video-player" (click)="onBackdropClick($event)">
  <div class="help-video-player__header" (click)="onBackdropClick($event)">
    <h2 class="help-video-player__title" id="help-video-player-title">
      {{ data.titleKey | translateLang }}
    </h2>
    <button
      type="button"
      class="help-video-player__close"
      (click)="close()"
      [attr.aria-label]="'common.close' | translateLang"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        aria-hidden="true"
      >
        <path d="M18 6L6 18M6 6l12 12" />
      </svg>
    </button>
  </div>

  <div class="help-video-player__stage" (click)="onBackdropClick($event)">
    <div class="help-video-player__frame">
      @if (data.embedUrl) {
        <iframe
          class="help-video-player__media"
          [src]="data.embedUrl"
          [title]="data.titleKey | translateLang"
          allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
          allowfullscreen
        ></iframe>
      } @else if (data.fileUrl) {
        <video
          class="help-video-player__media"
          controls
          autoplay
          playsinline
          [src]="data.fileUrl"
          [attr.aria-label]="data.titleKey | translateLang"
        ></video>
      }
    </div>
  </div>
</div>
